import { type LiteClient, liteClient } from "algoliasearch/lite";

/** Same hardcoded app id as the Vue app (SearchClaimTable.vue / ClaimCountersStore.ts). */
export const ALGOLIA_APP_ID = "X2I38XQM9R";

/** Single shared Algolia lite client factory — pair with the scoped key from GET /admin/search/key. */
export function createSearchClient(securedApiKey: string): LiteClient {
  return liteClient(ALGOLIA_APP_ID, securedApiKey);
}
